import { MessageCircle } from "lucide-react";

const WHATSAPP_URL =
  "https://wa.me/34678783000?text=" +
  encodeURIComponent("Hola Antonio, vengo de la web de Cinegética Ruta del Agua y quiero más información.");

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 rounded-full bg-[#25D366] text-white p-4 shadow-lg shadow-black/40 hover:scale-110 transition-transform duration-300"
      data-testid="whatsapp-float-button"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle size={26} strokeWidth={1.75} />
    </a>
  );
}
